/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Entity from 'fierry/data/entity';
import Cursor from 'fierry/data/cursor';

import Galaxy from 'solis/data/galaxy';
import CurrentTime from 'solis/data/current.time';
import Settings from 'solis/data/settings';


export default class Application extends Entity
{
  static create ()
  {
    return new Application(Application.getInitialState({}));
  }


  constructor (state)
  {
    super(new Cursor({ state }, []));
  }


  snapshot ()
  {
    return new Application(this.getState());
  }


  loadCurrentTime (cass)
  {
    this.getCurrentTime().load(cass);
  }


  loadSettings (cass)
  {
    this.getSettings().load(cass);
  }


  loadGalaxy (cass)
  {
    return Galaxy.load(this.cursor.child('galaxy'), cass, this);
  }


  unloadCurrentTime ()
  {
    this.getCurrentTime().unload();
  }


  unloadSettings ()
  {
    this.getSettings().unload();
  }


  unloadGalaxy ()
  {
    this.cursor.child('galaxy').remove();
  }


  createGalaxy (id)
  {
    return this.loadGalaxy({ id });
  }


  getCurrentTime ()
  {
    return new CurrentTime(this.cursor.child('currentTime'));
  }


  getSettings ()
  {
    return new Settings(this.cursor.child('settings'));
  }


  getGalaxy ()
  {
    return Galaxy.at(this.cursor.child('galaxy'), this);
  }


  getState ()
  {
    return this.cursor.get();
  }


};
